export default "__VITE_ASSET__422810a9__"